import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import ListRoles from './ListRoles';
import { GET_TEAM_ROLES } from './RolesContainer';
import TeamProvider, { TeamContext } from '../../../components/TeamProvider';

const tableTitle = 'Team Roles';

class TeamRoles extends Component {
  state = {
    open: true,
    teamID: TeamContext.getSelectedTeamId(),
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderError = () => (
    <commonComponents.ModalErrorDialog
      isOpen={this.state.open}
      onClose={this.handleClose}
      title="Team Roles"
      message="Oops, we could not access Role data!  Please try again later..."
    />
  );

  render() {
    const { open, teamID } = this.state;
    const { user, roleProp } = this.props;
    if (!open) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <TeamProvider user={user}>
        <TeamContext.Consumer>
          { ({ selectedTeam }) => (
            <Query
              query={GET_TEAM_ROLES}
              notifyOnNetworkStatusChange
              fetchPolicy="network-only"
              variables={{ teamID }}
              context={{ useLocalError: true }}
            >
              {({
                data, loading, error, refetch,
              }) => {
                if (error) {
                  return this.renderError();
                }
                return (
                  <ListRoles
                    {...this.props}
                    key={selectedTeam}
                    roles={data.allTeamRoles ? data.allTeamRoles : []}
                    title={tableTitle}
                    isLoading={loading}
                    refetch={refetch}
                    roleProp={roleProp}
                  />

                );
              }}
            </Query>
          )}
        </TeamContext.Consumer>
      </TeamProvider>
    );
  }
}

export default TeamRoles;
